import gql from 'graphql-tag';

import {useEntityTypeQuery} from '../generated/graphql';

export const ENTITY_PAGE_QUERY = gql`
  query EntityPage($entityName: String!) {
    entity(name: $entityName) {
      id
      isTeam
      entityType
      available
      claimingEntity {
        id
        name
      }
      members {
        id
        name
        username
        email
        photoUrl
        pending
        accountType
        role
      }
      name
    }
  }
`;

export const ENTITY_TYPE_QUERY = gql`
  query EntityType($entityName: String!) {
    entity(name: $entityName) {
      id
      entityType
    }
  }
`;

// These match the values in the services/gorilla/metadata/teams/entity.go file
export type EntityType = 'personal' | 'team' | 'organization';

export const useEntityTypeQueryResult = ({
  entityName,
  skip,
}: {
  entityName: string | undefined;
  skip?: boolean;
}) => {
  const {data, loading, error} = useEntityTypeQuery({
    variables: {entityName: entityName ?? ''},
    skip: entityName == null || skip,
  });

  return {
    entityType: data?.entity?.entityType as EntityType | undefined,
    loading,
    error,
  };
};
